import { FlexBox } from '@ardoq/layout';
import { text2Bold } from '@ardoq/typography';
import { css } from 'styled-components';

// setting the height is so that the badge fits inside of the select.
export const BADGE_CONTENT_HEIGHT = 18;

export const commonStyling = css`
  height: ${BADGE_CONTENT_HEIGHT}px;
  box-sizing: content-box;
  display: inline-flex;
  padding: 2px 4px 2px 4px;
  justify-content: center;
  align-items: center;
  gap: 0;
  border-radius: 999px;
  border: 1px solid;
  ${text2Bold};
`;

export const BadgeLabel = ({ label }: { label: string }) => (
  <FlexBox
    paddingX="xsmall"
    paddingY="none"
    justify="center"
    align="center"
    gap="small"
  >
    {label}
  </FlexBox>
);
